import { Modal, Typography, Button, styled, Box } from "@mui/material";

export const Container = styled(Modal)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const Content = styled(Box)(() => ({
  padding: "16px",
  background: "#FFF",
  alignItems: "center",
  justifyContent: "center",
}));

export const Title = styled(Typography)(() => ({
  fontSize: 18,
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: "16px",
}));

export const Label = styled(Typography)(() => ({
  textAlign: "center",
}));

export const CloseButton = styled(Button)(() => ({
  fontSize: 16,
  marginTop: "16px",
  fontWeight: "bold",
  textTransform: "uppercase",
}));
